/* eslint-disable i18next/no-literal-string -- theme - not user-facing text */
import { defineGlobalStyles } from '@chakra-ui/react';

export const styles = defineGlobalStyles({
  html: {
    // This sets the background for overscroll (bouncy scrolling)
    background: 'gray.25',
  },
  body: {
    minHeight: '100vh',
    fontSize: 'md',
    _dark: {
      fontSize: 'sm',
    },
  },
  // Chrome user agent stylesheet sets "normal" for some elements
  '*': {
    letterSpacing: '-0.02em',
  },
});
